@let requests = $requests();
@let isMobile = $isMobile();
@let isLoading = $loading();
@let isExpanded = $expanded();

@if ($shouldRender()) {
  <tui-accordion
    size="m"
    class="alternative-requests-widget-accordion"
    [ngClass]="{
      'rounded-(--tui-radius-xl)! mb-8': isMobile,
    }"
  >
    <button [tuiAccordion]="isExpanded" (tuiAccordionChange)="toggleExpanded()">
      <div class="flex items-center justify-between w-full pe-4">
        <h3 class="x-font-body-4-bold">
          {{ 'alternative_requests_widget.title' | translate }}
        </h3>
        <x-icon-button
          iconName="@tui.refresh-ccw"
          [iconSize]="16"
          [size]="32"
          [backgroundPrimary]="!isMobile"
          [disabled]="isLoading"
          tuiHintAppearance="dark"
          [clickFunction]="refreshRequests.bind(this)"
          class="accordion-header-button"
          [ngClass]="{ 'accordion-header-button__mobile': isMobile }"
        />
      </div>
    </button>
    <tui-expand class="x-white">
      <tui-loader
        [overlay]="true"
        [loading]="isLoading"
        [inheritColor]="true"
        size="m"
      >
        @if ($initialLoadFailed() && !requests.length) {
          <div class="px-4 py-3 text-center x-text-dark-secondary">
            {{ 'alternative_requests_widget.load_failed' | translate }}
          </div>
        } @else if (isMobile) {
          <div class="px-3 pb-3">
            @for (request of requests; track request.id) {
              <x-alternative-requests-widget-mobile-card
                [request]="request"
                class="block"
              />
            }
          </div>
        } @else {
          <div class="max-h-[420px] overflow-auto">
            <table
              tuiTable
              class="white-table [&_th]:align-top [&_td]:align-top"
            >
              <thead tuiThead>
                <tr>
                  @for (col of tableColumns; track col.key) {
                    <th
                      tuiTh
                      class="text-center"
                      [style.min-width]="col.minWidth ?? null"
                    >
                      {{ col.key | translate }}
                    </th>
                  }
                </tr>
              </thead>
              <tbody tuiTbody>
                @for (request of requests; track request.id) {
                  <tr
                    x-alternative-requests-widget-desktop-row
                    [request]="request"
                    class="row-colored-by-status cursor-pointer"
                    [routerLink]="['/requests', request.requestNumber]"
                    [style.--hover-color]="
                      hexToRgba(request.statusId?.color!, 0.3)
                    "
                    [style.--status-bg-color]="
                      hexToRgba(request.statusId?.color!, 0.1)
                    "
                  ></tr>
                }
              </tbody>
            </table>
          </div>
        }
      </tui-loader>
    </tui-expand>
  </tui-accordion>
}
